import { render, staticRenderFns } from "./ColorPalette.vue?vue&type=template&id=13f7532f&"
import script from "./ColorPalette.vue?vue&type=script&lang=js&"
export * from "./ColorPalette.vue?vue&type=script&lang=js&"
import style0 from "./ColorPalette.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ColorPalette.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports